'use strict';

// Order Summary - Basket Counter
$(document).ready(function() {
    $('#basket-form').hide();
    // IDM-7262
    $('[id*="networkSwitching_networkSwitchingDecision_row"]').addClass('hide');
    $('input[type="radio"][name*="networkSwitching][networkSwitchingDecision]').removeAttr('required');
    $('input[id*="networkSwitching_networkSwitchingStacCode"]:not([data-basket-id])').removeAttr('required');
    $('label[for$="networkSwitching_networkSwitchingPacCode"]').text('PAC/STAC code');
    // Select all divs whose id ends with the required suffix
    const stacDivs = document.querySelectorAll('div[id$="networkSwitching_networkSwitchingStacCode_row"]');
    stacDivs.forEach(function(stacDiv) {
        // Check if this div contains an input with data-network-switching-type
        var hasNetworkSwitchingInput;
        hasNetworkSwitchingInput = stacDiv.querySelector(
            '[data-network-switching-type]'
        );
        if (!hasNetworkSwitchingInput) {
            stacDiv.classList.add('hide');
        }
    });

    if ($('.basket-item').length) {
        $('.basket-item').each(function() {
            let basketLinePublicid = $(this).attr('data-public-id');
            var networkSwitchingIp = $(`input[data-basket-id="${basketLinePublicid}"]`);
            var dealNetworkSwitchingDecisionCodeIp = $(`input[data-basket-decision-code="${basketLinePublicid}"]`);
            var switchingStacCodeIp = $(`#form_${basketLinePublicid}-networkSwitching_networkSwitchingStacCode:not([data-basket-id])`);
            if (switchingStacCodeIp.length > 0) {
                switchingStacCode = switchingStacCodeIp.val();
                let switchingStacCode = (switchingStacCodeIp.val() || '').trim();
                if (switchingStacCode !== '') {
                    $(`input[type="radio"][name="form[${basketLinePublicid}-networkSwitching][networkSwitchingDecision]"][value="stac"]`).prop('checked', true);
                    networkSwitchingIp
                        .attr('data-validate', 'false')
                        .attr('id', `form_${basketLinePublicid}-networkSwitching_networkSwitchingStacCode`)
                        .attr('name', `form[${basketLinePublicid}-networkSwitching][networkSwitchingStacCode]`)
                        .attr('data-network-switching-type', 'stac')
                        .val(switchingStacCode);

                    dealNetworkSwitchingDecisionCodeIp
                        .attr('data-network-switching-decision', 'stac')
                        .val('stac');
                }
            }
        });
    }
    // end IDM-7262

    basketCounter.init();
    if ($('[data-has-accessibility-checkbox]').is(':checked')) {
        $('#billing_address_manual_form_street').removeAttr('required');
        $('#billing_address_manual_form_locality').removeAttr('required');
        $('#billing_address_manual_form_town').removeAttr('required');
        $('#billing_address_manual_form_county').removeAttr('required');
        $('#billing_address_manual_form_postcode').removeAttr('required');
        $('#billing_address_search_form_postcode').removeAttr('required');
        $('#billing_address_manual_form_houseNumber').removeAttr('required');
        $('[data-accessibility-options-container]').show();
        // $('[data-accessibility-option-select]').attr('required', 'required');
        $('[data-accessibility-option-select]').removeAttr('required');
    }

    $('body').on('click', '#basketTradeInSection', function() {
        $('#tradein-landing-modal').modal('show');
    });

    $('body').on('click', '[data-clear-trade-in-button]', function() {
        $('#tradein-landing-modal,#tradein-modal').modal('hide');
    });

    storeUrlParameters();

    var paramsStr = localStorage.getItem('affiliateUrlParams');
    if (paramsStr) {
        try {
            var paramsObj = JSON.parse(paramsStr);
            const queryString = Object.keys(paramsObj).map(function(key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(paramsObj[key]);
            }).join('&');
            if (queryString.includes('affiliate')) {
                localStorage.setItem('retainedAffiliateParams', queryString);
            }
        } catch (e) {
            console.error('Failed to parse affiliateUrlParams from localStorage', e);
        }
    }
    $('#form_name_forename, #form_name_surname').on('change', function() {
        setTimeout(function() {
            $('#details-form #form_phone_phoneNumber').trigger('input');
        }, 500);
    });

    $('#form_dateOfBirth_dateOfBirth_year, #form_dateOfBirth_dateOfBirth_month, #form_dateOfBirth_dateOfBirth_day').on('change', function() {
        setTimeout(function() {
            $('#details-form #form_phone_phoneNumber').trigger('input');
        }, 500);
    });
    // this would additionally check the fields shortly after the page loads:
    setTimeout(function() {
        $('#details-form #form_phone_phoneNumber').trigger('input');
    }, 1500);

    $('#details-form #form_phone_phoneNumber').on('input', function() {
        $('.selfcare-dialog').addClass('hidden');
        if (parseInt($('#aboutYouPageHead').data('phone-toggle-value')) == 1) {
            if (parseInt($('#aboutYouPageHead').data('phone-validataion-eligible')) !== 1) {
                return;
            }
            const isPhoneValid = this.checkValidity();
            if (!isPhoneValid) {
                return;
            }

            var firstName = $.trim($('#form_name_forename').val());
            var lastName = $.trim($('#form_name_surname').val());
            var year = $.trim($('#form_dateOfBirth_dateOfBirth_year').val());
            var month = $.trim($('#form_dateOfBirth_dateOfBirth_month').val());
            var day = $.trim($('#form_dateOfBirth_dateOfBirth_day').val());
            var phoneNumber = $.trim($('#form_phone_phoneNumber').val());

            // Don't call AJAX if any required field is empty
            if (!firstName || !lastName || !year || !month || !day || !phoneNumber || !isPhoneValid) {
                return;
            }

            var data = {
                firstName: firstName,
                lastName: lastName,
                dob: year + '-' + month + '-' + day,
                phoneNumber: phoneNumber
            };

            $('#form_phone_phoneNumber').addClass('form-spinner');
            $.ajax({
                url: '/beta/validate-phone-number',
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        $('.selfcare-dialog').removeClass('hidden');
                    }
                }
            }).always(() => {
                $('#form_phone_phoneNumber').removeClass('form-spinner');
            });
        }
    });

    $('.selfcare-dismiss').on('click', () => {
        $('.selfcare-card').addClass('hidden');
        $('.selfcare-show').removeClass('hidden');
    });

    $('.selfcare-show').on('click', () => {
        $('.selfcare-card').removeClass('hidden');
        $('.selfcare-show').addClass('hidden');
    });

});
jQuery(function($) {
    var $status = $('#form_employment_employmentStatus');
    var $label = $('label[for="form_employment_timeWithEmployer"]');
    // Map each status to its label text
    var LABELS = {
        // eslint-disable-next-line line-comment-position
        '': 'Time with employer?', // default when "Select" is chosen
        'employed': 'Time with employer?',
        'unemployed': 'How long have you been unemployed?',
        'retired': 'How long have you been retired?',
        'student': 'How long have you been a student?',
        'house person': 'How long have you been a house person?',
        'self-employed': 'How long have you been self employed?'
    };
    function updateTimeWithEmployerLabel() {
        var val = $status.val() || '';
        var text = LABELS.hasOwnProperty(val) ? LABELS[val] : LABELS[''];
        $label.text(text);
    }
    // On change, update label
    $status.on('change', updateTimeWithEmployerLabel);
    // Initialize on page load to reflect any preselected value
    updateTimeWithEmployerLabel();
});
// functions for affiliate URL parameter handling
function storeUrlParameters() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const paramObj = {};

    // Store all URL parameters
    for (let [key, value] of params.entries()) {
        paramObj[key] = value;
    }

    localStorage.setItem('affiliateUrlParams', JSON.stringify(paramObj));
}

$(function() {
    if ($('.addressBlock').length) {
        $('.addressBlock').each(function() {
            if ($(this).hasClass('hide')) {
                $(this).removeClass('hide');
            }
        });
    }
});

// iD Main Nav
$('.toggle-menu').on('click', function() {
    let header = $(this).closest('.id-header');
    header.toggleClass('menu-open').promise().done(function() {
        $('body').toggleClass('overflow-hidden-xs overflow-hidden-sm', header.hasClass('menu-open'));
    });
});

let submitButton = $('.submit-page-form-button');

$("input[name='form[customerDocumentAccessibilityPreference][documentAccessibilityOption]']").on('click', function() {
    if ($("input[name='form[customerDocumentAccessibilityPreference][documentAccessibilityOption]']:checked").val() !== 'no') {
        submitButton.text('Place order');
        submitButton.removeAttr('data-target');
    } else {
        submitButton.text('Request Documents');
        submitButton.attr('data-target', '#documentOption');
    }
});

let searchInput = $('.id-search input[type="search"]'),
    searchButton = $('.id-search button[type="submit"]');

$(searchInput)
    .on('focus', function() {
        searchButton.prop('disabled', true);
        if ($('.hidden-xs').is(':visible')) {
            $(this).attr('placeholder', 'Search');
        }
    })
    .on('keyup', function() {
        if ($(this).val().trim().length > 0) {
            searchButton.prop('disabled', false);
        } else {
            searchButton.prop('disabled', true);
        }
    });

// Submit Form Button with unique ID
let formId = $('.page-form').attr('id');
const scrollToError = () => {
    const errorsShown = '.has-error:visible, .msg-box-error:visible',
        headerHeight = $('.id-checkout-header').height();
    if ($(errorsShown).length) {
        $('html, body').animate({
            scrollTop: ($(errorsShown).first().offset().top - headerHeight)
        }, 750);
    }
};

$('.submit-page-form-button').click(function(e) {
    $('#billing_address_search_form_months_months_row .help-block').css('display', 'none');
    $('#billing_address_search_form_months_years_row .help-block').css('display', 'none');

    $('#form_employment_employmentStatus').attr('required', 'true');
    $('#form_employment_timeWithEmployer').attr('required', 'true');
    $('#form_residentialStatus_residentialStatus').attr('required', 'true');

    $('#billing_address_manual_form_street').removeAttr('required');
    $('#billing_address_manual_form_locality').removeAttr('required');
    $('#billing_address_manual_form_town').removeAttr('required');
    $('#billing_address_manual_form_county').removeAttr('required');
    $('#billing_address_manual_form_postcode').removeAttr('required');
    $('#billing_address_manual_form_houseNumber').removeAttr('required');
    $('#billing_address_manual_form_months_years').removeAttr('required');
    $('#billing_address_manual_form_months_months').removeAttr('required');

    $('#billing_address_search_form_months_months').removeAttr('required');
    $('#billing_address_search_form_months_years').removeAttr('required');
    $('#billing_address_search_form_postcode').removeAttr('required');
    $('#billing_address_search_form_houseNumberName').removeAttr('required');

    if ($('[data-address-id="billing_address_manual_link"]').is(':visible')) {

        $('#billing_address_manual_form_street').removeAttr('required');
        $('#billing_address_manual_form_town').removeAttr('required');
        $('#billing_address_manual_form_postcode').removeAttr('required');
        $('#billing_address_manual_form_houseNumber').removeAttr('required');

        $('#billing_address_manual_form_months_years').removeAttr('required');
        $('#billing_address_manual_form_months_months').removeAttr('required');

        $('#billing_address_search_form_months_months').attr('required', 'true');
        $('#billing_address_search_form_months_years').attr('required', 'true');
        $('#billing_address_search_form_postcode').attr('required', 'true');
        $('#billing_address_search_form_houseNumberName').attr('required', 'true');
    }

    if ($('[data-address-id="billing_address_search_link"]').is(':visible')) {
        $('#billing_address_manual_form_street').attr('required', 'true');
        $('#billing_address_manual_form_town').attr('required', 'true');
        $('#billing_address_manual_form_postcode').attr('required', 'true');
        $('#billing_address_manual_form_houseNumber').attr('required', 'true');

        $('#billing_address_manual_form_months_years').attr('required', 'true');
        $('#billing_address_manual_form_months_months').attr('required', 'true');

        $('#billing_address_manual_form_months_years_row .help-block').css('display', 'none');
        $('#billing_address_manual_form_months_months_row .help-block').css('display', 'none');

        $('#billing_address_search_form_months_months').removeAttr('required');
        $('#billing_address_search_form_months_years').removeAttr('required');
        $('#billing_address_search_form_postcode').removeAttr('required');
        $('#billing_address_search_form_houseNumberName').removeAttr('required');
    }

    $('#details-form').validator('validate');
    if ($('#details-form').length) {
        if ($('#details-form').validator().data('bs.validator').hasErrors()) {
            $('#default-form-error-box').show();
        } else {
            $('#default-form-error-box').hide();
        }

        if ($('#billing_address_manual_form_months_years').val() == '' && $('#billing_address_manual_form_months_months').val() == '') {
            $('#time-at-address-manual-error-box').show();
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_manual_form_months_years').val() == '' && $('#billing_address_manual_form_months_months').val() != '') {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').show();
        } else if ($('#billing_address_manual_form_months_years').val() != '' && $('#billing_address_manual_form_months_months').val() != '') {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_manual_form_months_years').val() != '' && $('#billing_address_manual_form_months_months').val() == '') {
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
            $('#time-at-address-manual-error-box').show();
        }

        if ($('#billing_address_search_form_months_years').val() == '' && $('#billing_address_search_form_months_months').val() == '') {
            $('#time-at-address-search-error-box').show();
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_search_form_months_years').val() == '' && $('#billing_address_search_form_months_months').val() != '') {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').show();
        } else if ($('#billing_address_search_form_months_years').val() != '' && $('#billing_address_search_form_months_months').val() != '') {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_search_form_months_years').val() != '' && $('#billing_address_search_form_months_months').val() == '') {
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
            $('#time-at-address-search-error-box').show();
        }

        if ($('#form_employment_employmentStatus').length && $('#form_employment_employmentStatus').is(':invalid')) {
            $('#form_employment_employmentStatus:invalid').css('border-color', '#DD0251');
        }

        if ($('#form_employment_timeWithEmployer').length && $('#form_employment_timeWithEmployer').is(':invalid')) {
            $('#form_employment_timeWithEmployer:invalid').css('border-color', '#DD0251');
        }

        if ($('#form_residentialStatus_residentialStatus').length && $('#form_residentialStatus_residentialStatus').is(':invalid')) {
            $('#form_residentialStatus_residentialStatus:invalid').css('border-color', '#DD0251');
        }
    }
    scrollToError();

    if ($(':input', '[data-address-id="billing_address_content_block"]').each(function() {
        if ($(this).val() != '') {
            return true;
        }
    })) {
        if ($('button', '[data-address-id="billing_address_find_address_button"]').is(':visible')) {
            $('button', '[data-address-id="billing_address_find_address_button"]').click();
            return;
        }
        if ($('button', '[data-address-id="billing_address_add_address_button"]').is(':visible')) {
            $('button', '[data-address-id="billing_address_add_address_button"]').click();
            return;
        }
    }

    let confirmNetworkSwitchingButton = document.querySelector('[data-network-switching-button]');
    let networkSwitchingConsentCheckbox = document.querySelector('[data-network-switching-confirmation]');

    if (confirmNetworkSwitchingButton && confirmNetworkSwitchingButton.disabled == false && networkSwitchingConsentCheckbox.checked) {
        e.preventDefault();
        document.querySelector('[data-network-switching-button-error]').classList.remove('hidden');
        return;
    }

    let documentAccessibilityOption = $("input[name='form[customerDocumentAccessibilityPreference][documentAccessibilityOption]']");
    let chosenDocumentAccessibilityOptionValue = null;
    if (documentAccessibilityOption.length) {
        chosenDocumentAccessibilityOptionValue = $("input[name='form[customerDocumentAccessibilityPreference][documentAccessibilityOption]']:checked").val();
    }

    if (chosenDocumentAccessibilityOptionValue == 'no') {
        e.preventDefault();
        setAccessibilityPayloadRecordReadyForProcessing($('#' + formId).serialize());
    } else {
        $('#' + formId).submit();
    }
});

// Link T&C's checkbox with Summary Form
$('.terms-conditions-container input').attr('form', 'summary-form');
$('.document-accessibility-container input').attr('form', 'summary-form');

// Disable submit on terms page to prevent duplicate orders
$('#summary-form').on('submit', function(event) {
    let networkSwitchingDatePicker = document.querySelector('[data-network-switching] input[data-date-choices]');
    if (networkSwitchingDatePicker) {
        let networkSwitchingConsentCheckbox = document.querySelector('[data-network-switching-confirmation]');
        networkSwitchingDatePicker.closest('.form-group').classList.remove('has-error');
        networkSwitchingConsentCheckbox.closest('.form-group').classList.remove('has-error');
        if (networkSwitchingDatePicker.checkVisibility()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (networkSwitchingDatePicker.value === '') {
                networkSwitchingDatePicker.closest('.form-group').classList.add('has-error');
            } else if (networkSwitchingConsentCheckbox.checked === false) {
                networkSwitchingConsentCheckbox.closest('.form-group').classList.add('has-error');
            }
            scrollToError();
            return false;
        }
    }
    $('.submit-page-form-button').attr('disabled', true);
});

$('#details-form input[type="radio"]').on('invalid.bs.validator', function() {

    /* Set focus on the brand logo to avoid UI issues when validation errors appear */
    document.querySelector('.id-checkout-header .id-logo a').focus();
});

$('#summary-form input').on('invalid.bs.validator', function() {
    $('.submit-page-form-button').removeAttr('disabled');
});

// Set offset for Bootstrap form validation
let headerHeight = $('.id-checkout-header').height();

$.fn.validator.Constructor.FOCUS_OFFSET = headerHeight + 50;

// Voucher code spinner
$('.enter-voucher button').on('click', function() {
    $(this).text('').append('<span class="brand-white-icon spinner icon-spin"></span>');
});

// Bill capping content control
$('.billcap-button').on('click', function(event) {
    event.preventDefault();
    const publicId = $(this).data('public-id');
    const targetItem = `.basket-item[data-public-id=${publicId}]`;
    const enableBillcap = $(this).attr('data-remove-bill-cap') === undefined;
    if (enableBillcap) {
        $(`${targetItem} .billcap-modal`).removeClass('hidden');
        $(`${targetItem} .billcap-default-content`).addClass('hidden');
        $(`${targetItem} .billcap-button`).attr('data-remove-bill-cap', true);
        $(`${targetItem} .billcap-button`).text('Remove Bill Cap');
        document.getElementById(`cap-${publicId}-5.00`).parentElement.click();
        $(`#cap-${publicId}-5.00`).click();
    } else {
        setBillCapping({
            enableBillcap: false,
            billCapValue: 0,
            publicId,
        });
        $(`${targetItem} .billcap-modal`).addClass('hidden');
        $(`${targetItem} .billcap-default-content`).removeClass('hidden');
        $(`${targetItem} .billcap-options input`).prop('checked', false);
        $(`${targetItem} .billcap-button`).removeAttr('data-remove-bill-cap', false);
        $(`${targetItem} .billcap-button`).text('Add Bill Cap');
    }
});

$('.billcap-options label').on('click', function() {
    const inputEl = $(this).find('input');
    const billCapValue = inputEl.val();
    const publicId = inputEl.data('public-id');
    setBillCapping({
        enableBillcap: true,
        billCapValue,
        publicId,
    });
});

function setBillCapping({
    enableBillcap, billCapValue, publicId
}) {
    $(`#billCappingDecision-${publicId}`).val(enableBillcap ? 1 : 0);
    $(`#billCappingAmount-${publicId}`).val(billCapValue);
}

$('.bill-capping-submit').on('click', function() {
    let basketItemList = document.getElementsByClassName('basket-item');
    for (let i = 0; i < basketItemList.length; i++) {
        let basketLinePublicid = basketItemList[i].getAttribute('data-public-id');
        $('#form_' + basketLinePublicid + '_billCappingDecision').val(0);
        $('#form_' + basketLinePublicid + '_billCappingAmount').val('0.00');
    }
});
// Bill capping END

let documentDownloadButtonSelector = '[data-download-document-endpoint]';

if (document.querySelector(documentDownloadButtonSelector)) {
    let endpoint = document.querySelector(documentDownloadButtonSelector + ':first-of-type').dataset.downloadDocumentEndpoint;

    fetch(endpoint)
        .then(function(response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        })
        .then((json) => {
            json = json.documents;
            for (const documentId in json) {
                const button = document.querySelector('[data-document-id="' + documentId + '"]');

                if (button) {
                    let fileType = navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod|firefox)/g) ? 'octet-stream' : 'pdf';
                    button.href = 'data:application/' + fileType + ';base64,' + json[documentId].pdfbase64;
                    button.setAttribute('data-loaded', true);
                }
            }
            document.querySelectorAll(documentDownloadButtonSelector + "[data-loaded='false']").forEach(function(button) {
                button.setAttribute('disabled', true);
            });
        })
        .catch(function() {
            document.querySelectorAll(documentDownloadButtonSelector).forEach(function(button) {
                button.setAttribute('disabled', 'disabled');
                button.classList.add('disabled');
            });
        });
}

$('.form_transferCode_portingStatus label').on('click', function() {
    let nowOrLaterValue = $(this).find('input').val();
    $(document).on('change', 'input', function() {
        $('.pac-or-stac-details').toggleClass('hide', nowOrLaterValue === 'later');
    });
});

// dataLayer push
let gtmLastFormErrorText = '',
    fieldName = '';
function containsLastFormErrorText(element) {
    return element.errorText_fieldName === gtmLastFormErrorText + '_' + fieldName;
}
function dataLayerPushDetailsError(gtmLastFormErrorText, fieldName) {
    if (window.dataLayer) {
        let found = window.dataLayer.some(containsLastFormErrorText);
        if (!found) {
            window.dataLayer.push({
                'event': 'formValidationError',
                'errorText_fieldName': gtmLastFormErrorText + '_' + fieldName
            });
        }
    }
}
$('#details-form input, #details-form select').on('invalid.bs.validator', function(event) {
    if ($(this).data('error') !== undefined) {
        gtmLastFormErrorText = $(this).data('error');
    } else if (event.target.validationMessage !== undefined) {
        gtmLastFormErrorText = event.target.validationMessage;
    }
    fieldName = $(this).attr('id');
    dataLayerPushDetailsError(gtmLastFormErrorText, fieldName);
});
$('[data-form-field]').each(function() {
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
        target = this,
        observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName == 'class' && mutation.target.classList.contains('msg-box-error')) {
                    gtmLastFormErrorText = target.innerText;
                    fieldName = target.getAttribute('data-form-field');
                    dataLayerPushDetailsError(gtmLastFormErrorText, fieldName);
                }
            });
        });
    observer.observe(target, {
        attributes: true
    });
});
$(function() {
    $('[data-form-field^="upgrades_customer_"]').each(function() {
        gtmLastFormErrorText = this.innerText;
        fieldName = this.getAttribute('data-form-field');
        dataLayerPushDetailsError(gtmLastFormErrorText, fieldName);
    });
});

$(function() {
    $('[data-has-accessibility-checkbox]').change(function() {
        if (this.checked !== true) {
            $('[data-accessibility-options-container]').hide();
            $('[data-accessibility-option-select]').removeAttr('required');
        } else {
            $('#billing_address_manual_form_street').removeAttr('required');
            $('#billing_address_manual_form_locality').removeAttr('required');
            $('#billing_address_manual_form_town').removeAttr('required');
            $('#billing_address_manual_form_county').removeAttr('required');
            $('#billing_address_manual_form_postcode').removeAttr('required');
            $('#billing_address_search_form_postcode').removeAttr('required');
            $('#billing_address_manual_form_houseNumber').removeAttr('required');
            $('[data-accessibility-options-container]').show();
            $('[data-accessibility-option-select]').attr('required', 'required');
        }
    });
});

function setAccessibilityPayloadRecordReadyForProcessing(data) {
    $('.global-msg-boxes').html('');
    $.post({
        url: '/beta/checkout/accessibility/document/choice',
        data: data,
        success: function(data) {
            processResponse(data);
        }
    });
}

var processResponse = function(data) {
    if (data.status == 'success') {
        $('#documentOption').modal('show');
        const transactionIdElement = document.querySelector('[data-document-transaction-id]');
        if (transactionIdElement) {
            dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'accessibilityModalInteraction',
                'eventAction': 'modal shown',
                'eventLabel': '', /* This is intentionally blank, to ensure any previous value is overwritten */
                'documentRequestId': transactionIdElement.dataset.documentTransactionId
            });
        }
    } else {
        $('.global-msg-boxes').html('<div class="global-msg-boxes"><div class="msg-box msg-box-error"><span class="msg-box-icon"></span><p>Oops, it looks like there has been a problem. Please wait a few moments and try again.</p></div></div>');
    }
};

$('#form_employment_employmentStatus_row, #form_employment_timeWithEmployer_row, #form_residentialStatus_row').on('change', 'select', function() {
    if ($(this).val() != '') {
        $(this).css('border-color', '#000');
    } else {
        $(this).css('border-color', '#d0021b');
    }
});

$('[data-address-id="billing_address_manual_link"]').on('click', function() {
    $('#billing_address_manual_form_street').attr('required', 'true');
    $('#billing_address_manual_form_town').attr('required', 'true');
    $('#billing_address_manual_form_postcode').attr('required', 'true');
    $('#billing_address_manual_form_houseNumber').attr('required', 'true');

    $('#billing_address_manual_form_months_years').attr('required', 'true');
    $('#billing_address_manual_form_months_months').attr('required', 'true');

    $('#billing_address_manual_form_months_years_row .help-block').css('display', 'none');
    $('#billing_address_manual_form_months_months_row .help-block').css('display', 'none');

    $('#billing_address_search_form_months_months').removeAttr('required');
    $('#billing_address_search_form_months_years').removeAttr('required');
    $('#billing_address_search_form_postcode').removeAttr('required');
    $('#billing_address_search_form_houseNumberName').removeAttr('required');
});

$('[data-address-id="billing_address_search_link"]').on('click', function() {
    $('#billing_address_manual_form_street').removeAttr('required');
    $('#billing_address_manual_form_town').removeAttr('required');
    $('#billing_address_manual_form_postcode').removeAttr('required');
    $('#billing_address_manual_form_houseNumber').removeAttr('required');

    $('#billing_address_manual_form_months_years').removeAttr('required');
    $('#billing_address_manual_form_months_months').removeAttr('required');

    $('#billing_address_search_form_months_months').attr('required', 'true');
    $('#billing_address_search_form_months_years').attr('required', 'true');
    $('#billing_address_search_form_postcode').attr('required', 'true');
    $('#billing_address_search_form_houseNumberName').attr('required', 'true');
});

/*   for month and year search address error */
$('#billing_address_search_form_months_months')
    .on('keyup', function() {
        if ($(this).val() == '') {
            $('#billing_address_search_form_months_months_row').addClass('has-error');
        } else {
            $('#billing_address_search_form_months_months_row').removeClass('has-error');
        }

        if ($(this).val() == '') {
            $('#time-at-address-search-error-box').show();
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_search_form_months_years').val() == '') {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').show();
        } else {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        }
    });

$('#billing_address_search_form_months_years')
    .on('keyup', function() {
        if ($(this).val() == '') {
            $('#billing_address_search_form_months_years_row').addClass('has-error');
        } else {
            $('#billing_address_search_form_months_years_row').removeClass('has-error');
        }

        if ($(this).val() == '' && $('#billing_address_search_form_months_months').val() == '') {
            $('#time-at-address-search-error-box').show();
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        } else if ($(this).val() == '' && $('#billing_address_search_form_months_months').val() != '') {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').show();
        } else if ($(this).val() != '' && $('#billing_address_search_form_months_months').val() != '') {
            $('#time-at-address-search-error-box').css('display', 'none');
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
        } else if ($(this).val() != '' && $('#billing_address_search_form_months_months').val() == '') {
            $('#time-at-address-search-error-box-single-err').css('display', 'none');
            $('#time-at-address-search-error-box').show();
        }
    });

/*   for month and year manual address error */
$('#billing_address_manual_form_months_months')
    .on('keyup', function() {
        if ($(this).val() == '') {
            $('#time-at-address-manual-error-box').show();
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        } else if ($('#billing_address_manual_form_months_years').val() == '') {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').show();
        } else {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        }
    });

$('#billing_address_manual_form_months_years')
    .on('keyup', function() {
        if ($(this).val() == '' && $('#billing_address_manual_form_months_months').val() == '') {
            $('#time-at-address-manual-error-box').show();
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        } else if ($(this).val() == '' && $('#billing_address_manual_form_months_months').val() != '') {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').show();
        } else if ($(this).val() != '' && $('#billing_address_manual_form_months_months').val() != '') {
            $('#time-at-address-manual-error-box').css('display', 'none');
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
        } else if ($(this).val() != '' && $('#billing_address_manual_form_months_months').val() == '') {
            $('#time-at-address-manual-error-box-single-err').css('display', 'none');
            $('#time-at-address-manual-error-box').show();
        }
    });

/* for removing error box  if no error */
$('body').on('input', '#details-form', function() {
    if ($('#details-form').validator().data('bs.validator').hasErrors()) {
        // keeping it blank //
    } else {
        $('#default-form-error-box').css('display', 'none');
    }

});

/* GA4 add_to_cart for frequently bought accessories in basket when we click on add to basket */
$(document).on('click', '.accessory-add-to-basket[data-buy-accessory]', function() {
    var itemArr = [];
    var thisPlan = {};
    let eventName = $(this).is('[data-remove-accessory]') ? 'remove_from_cart' : 'add_to_cart';
    var $btn = $(this);
    var $swiper = $btn.closest('.accessory-swiper');
    var $slides = $swiper.find('.swiper-slide').not('.swiper-slide-duplicate');
    var containerRect = $swiper[0].getBoundingClientRect();
    var visibleSlides = [];
    $slides.each(function() {
        var rect = this.getBoundingClientRect();
        // Include partially + fully visible slides
        var isVisible =
            rect.right > containerRect.left &&
            rect.left < containerRect.right;
        if (isVisible) {
            visibleSlides.push(this);
        }
    });

    /* Sort by actual visual order */
    visibleSlides.sort(function(a, b) {
        return a.getBoundingClientRect().left -
            b.getBoundingClientRect().left;
    });
    var clickedSlide = $btn.closest('.swiper-slide')[0];

    /* Zero-based visible index */
    var visibleIndex = visibleSlides.indexOf(clickedSlide);

    /* Fallback */
    if (visibleIndex < 0) {
        visibleIndex = 0;
    }
    //  below code is to get the parent product family name
    var parentVoucher = $(this).data('parent-id');
    var productParentFamily = $('.basket-item[data-public-id="' + parentVoucher + '"]').attr('data-product-family').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    thisPlan['item_id'] = $(this).data('product-code');
    thisPlan['item_name'] = 'Accessories: ' + $(this).data('product-name');
    thisPlan['item_category'] = 'ACC';
    thisPlan['product_deal_id'] = String($(this).data('deal-id'));
    // Hardcoding as In Stock as we are showing only in stock products
    thisPlan['product_availability'] = 'In Stock';
    thisPlan['product_data_variation'] = '';
    thisPlan['product_third_party_code'] = $(this).data('thirdparty-code');
    thisPlan['product_tariff_code'] = $(this).data('tariffcode');
    thisPlan['product_up_front_cost'] = String($(this).data('price'));
    thisPlan['product_model'] = 'Accessories';
    thisPlan['deal_tag'] = '';
    thisPlan['product_card_ribbon'] = '';
    thisPlan['product_promotion'] = '';
    thisPlan['item_brand'] = $(this).data('brand');
    thisPlan.quantity = 1;
    thisPlan.index = 0;
    thisPlan.price = Number($(this).data('price'));
    itemArr.push(thisPlan);
    dataLayer.push(
        {
            'ecommerce': null
        }
    );
    dataLayer.push({
        'event': eventName,
        'ecommerce': {
            'currency': 'GBP',
            'value': Number($(this).data('price')),
            'item_list_name': 'basket_accessories_carousel_' + productParentFamily,
            'items': itemArr
        }
    });
});

(function() {
    var code = $('[data-basket-summary-full]').data('code');
    const affiliateAddToCart = $('[data-basket-summary-full]').attr('data-affiliate-add-to-cart') === 'true';
    const affiliateDealId = $('[data-basket-summary-full]').attr('data-affiliate-deal-id');
    // eslint-disable-next-line no-console
    if (code == 'home') {
        var items = [];
        // sum of all prices
        var totalValue = 0;
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];
        const dataLayer = window.dataLayer;

        // Clear previous ecommerce object (GA4 requirement)
        dataLayer.push({
            ecommerce: null
        });
        const hstarid = localStorage.getItem('hstarid');
        const addToCartClicked = localStorage.getItem('addtocartclicked') === 'true';
        let pushed = false;
        const processedAffiliateDealIds = new Set();
        $('.basket-item').each(function() {
            var $el = $(this);
            let dealTagArr = JSON.parse($el.attr('data-deal_tag') || '[]');
            let dealTagStr = dealTagArr.join(', ');
            const itemCategory = $el.attr('data-item_category') || '';
            let storageKey = '';
            if (itemCategory === 'HAN' || itemCategory === 'SFH') {
                storageKey = $el.attr('data-item_basecode') || '';
            } else {
                storageKey = $el.attr('data-product_deal_id') || '';
            }
            let obj = {};
            if (storageKey) {
                const raw = localStorage.getItem(storageKey);
                if (raw) {
                    try {
                        const parsed = JSON.parse(raw);

                        // Use only if it's a plain object (not null/array/primitive)
                        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                            obj = parsed;
                        } else {
                            obj = {};
                        }
                    } catch (e) {
                        obj = {};
                    }
                }
            }
            const pageTitle = (obj && typeof obj.pageTitle === 'string') ? obj.pageTitle : '';
            const pageUrl = (obj && typeof obj.pageUrl === 'string') ? obj.pageUrl : '';
            // eslint-disable-next-line no-console
            console.log('pageTitle:', pageTitle);
            // eslint-disable-next-line no-console
            console.log('pageUrl:', pageUrl);
            var item = {};

            // READ PRICE
            let price = Number($el.attr('data-price')) || 0;
            item['price'] = price;

            // SUM TOTAL PRICE
            totalValue += price;

            item['item_id'] = $el.attr('data-item_id');
            item['item_name'] = $el.attr('data-item_name');
            item['index'] = 0;
            item['price'] = Number($el.attr('data-price'));

            item['item_brand'] = $el.attr('data-item_brand');
            item['item_category'] = $el.attr('data-item_category');
            item['item_category2'] = $el.attr('data-item_category2');
            item['item_category3'] = $el.attr('data-item_category3');
            item['item_category4'] = $el.attr('data-item_category4');
            item['item_category5'] = $el.attr('data-item_category5');
            item['item_variant'] = $el.attr('data-item_variant');
            item['quantity'] = 1;

            item['product_availability'] = $el.attr('data-product_availability');
            item['product_deal_id'] = String($el.attr('data-product_deal_id'));
            item['product_data_variation'] = $el.attr('data-product_data_variation');
            item['product_third_party_code'] = $el.attr('data-product_third_party_code');
            item['product_tariff_code'] = $el.attr('data-product_tariff_code');
            item['product_contract_length'] = $el.attr('data-product_contract_length');
            item['product_texts_allowance'] = $el.attr('data-product_texts_allowance');
            item['product_up_front_cost'] = $el.attr('data-product_up_front_cost');

            // special handling
            item['5g_enabled'] = $el.attr('data-5g_enabled');
            item['e_sim_enabled'] = $el.attr('data-e_sim_enabled');

            item['product_model'] = $el.attr('data-product_model');
            item['product_capacity'] = $el.attr('data-product_capacity');

            // deal tags
            item['deal_tag'] = dealTagStr;

            item['product_card_ribbon'] = $el.attr('data-product_card_ribbon');
            item['product_promotion'] = $el.attr('data-product_promotion');
            item['product_colour'] = $el.attr('data-product_colour');
            item['refurbished'] = $el.attr('data-refurbished');

            item['item_list_id'] = pageTitle;
            item['item_list_name'] = pageUrl;
            $el.attr('data-item_list_id', pageTitle);
            $el.attr('data-item_list_name', pageUrl);
            items.push(item);
            const dealId = $el.attr('data-product_deal_id');
            if (affiliateAddToCart && affiliateDealId && dealId === affiliateDealId && !processedAffiliateDealIds.has(dealId)) {
                processedAffiliateDealIds.add(dealId);
                dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: 'GBP',
                        value: item.price,
                        items: [item]
                    }
                });
            }
            if (addToCartClicked && hstarid && dealId === hstarid) {
                // individual add_to_cart
                dataLayer.push({
                    // 'event': 'select_item', // IDM7905 ticket updates
                    'event': 'add_to_cart',
                    'ecommerce': {
                        currency: 'GBP',
                        // SUM OF ALL ITEM PRICES
                        value: totalValue,
                        // 'items': items
                        'items': [item]
                    }
                });
                pushed = true;
            }
            if (pushed) {
                localStorage.removeItem('addtocartclicked');
                localStorage.removeItem('hstarid');
            }
        });
    }
})();

(function() {
    var code = $('[data-basket-summary-full]').data('code');
    // eslint-disable-next-line no-console
    if (code == 'home') {
        var items = [];
        // sum of all prices
        var totalValue = 0;
        $('.basket-item').each(function() {
            var $el = $(this);
            let dealTagArr = JSON.parse($el.attr('data-deal_tag') || '[]');
            let dealTagStr = dealTagArr.join(', ');
            const itemCategory = $el.attr('data-item_category') || '';
            let storageKey = '';
            if (itemCategory === 'HAN' || itemCategory === 'SFH') {
                storageKey = $el.attr('data-item_basecode') || '';
            } else {
                storageKey = $el.attr('data-product_deal_id') || '';
            }
            let obj = {};
            if (storageKey) {
                const raw = localStorage.getItem(storageKey);
                if (raw) {
                    try {
                        const parsed = JSON.parse(raw);
                        // Use only if it's a plain object (not null/array/primitive)
                        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                            obj = parsed;
                        } else {
                            obj = {};
                        }
                    } catch (e) {
                        obj = {};
                    }
                }
            }
            const pageTitle = (obj && typeof obj.pageTitle === 'string') ? obj.pageTitle : '';
            const pageUrl = (obj && typeof obj.pageUrl === 'string') ? obj.pageUrl : '';
            var item = {};
            // READ PRICE
            let price = Number($el.attr('data-price')) || 0;
            item['price'] = price;
            // SUM TOTAL PRICE
            totalValue += price;
            item['item_id'] = $el.attr('data-item_id');
            item['item_name'] = $el.attr('data-item_name');
            item['index'] = Number($el.attr('data-index'));
            item['price'] = Number($el.attr('data-price'));
            item['item_brand'] = $el.attr('data-item_brand');
            item['item_category'] = $el.attr('data-item_category');
            item['item_category2'] = $el.attr('data-item_category2');
            item['item_category3'] = $el.attr('data-item_category3');
            item['item_category4'] = $el.attr('data-item_category4');
            item['item_category5'] = $el.attr('data-item_category5');
            item['item_variant'] = $el.attr('data-item_variant');
            item['quantity'] = 1;
            item['product_availability'] = $el.attr('data-product_availability');
            item['product_deal_id'] = $el.attr('data-product_deal_id');
            item['product_data_variation'] = $el.attr('data-product_data_variation');
            item['product_third_party_code'] = $el.attr('data-product_third_party_code');
            item['product_tariff_code'] = $el.attr('data-product_tariff_code');
            item['product_contract_length'] = $el.attr('data-product_contract_length');
            item['product_texts_allowance'] = $el.attr('data-product_texts_allowance');
            item['product_up_front_cost'] = $el.attr('data-product_up_front_cost');
            // special handling
            item['5g_enabled'] = $el.attr('data-5g_enabled');
            item['e_sim_enabled'] = $el.attr('data-e_sim_enabled');
            item['product_model'] = $el.attr('data-product_model');
            item['product_capacity'] = $el.attr('data-product_capacity');
            // deal tags
            item['deal_tag'] = dealTagStr;
            item['product_card_ribbon'] = $el.attr('data-product_card_ribbon');
            item['product_promotion'] = $el.attr('data-product_promotion');
            item['product_colour'] = $el.attr('data-product_colour');
            item['refurbished'] = $el.attr('data-refurbished');
            item['item_list_id'] = pageTitle;
            item['item_list_name'] = pageUrl;
            $el.attr('data-item_list_id', pageTitle);
            $el.attr('data-item_list_name', pageUrl);
            items.push(item);
        });
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];
        const dataLayer = window.dataLayer;
        // Clear previous ecommerce object (GA4 requirement)
        dataLayer.push({
            ecommerce: null
        });

        dataLayer.push({
            'event': 'view_cart',
            'ecommerce': {
                currency: 'GBP',
                // SUM OF ALL ITEM PRICES
                value: totalValue,
                'items': items
            }
        });
    }
})();

$(document).on('click', '#remove-form', function() {
    var items = [];
    var item = {};
    const $form = $(this);
    const basketItem = $form.closest('.basket-item');
    const $el = $(basketItem);
    let dealTagArr = JSON.parse($el.attr('data-deal_tag') || '[]');
    let dealTagStr = dealTagArr.join(', ');
    item['item_id'] = $el.attr('data-item_id') || '';
    item['item_name'] = $el.attr('data-item_name') || '';
    item['price'] = Number($el.attr('data-price'));
    item['item_brand'] = $el.attr('data-item_brand') || '';
    item['item_category'] = $el.attr('data-item_category') || '';
    item['item_category2'] = $el.attr('data-item_category2') || '';
    item['item_category3'] = $el.attr('data-item_category3') || '';
    item['item_category4'] = $el.attr('data-item_category4') || '';
    item['item_category5'] = $el.attr('data-item_category5') || '';
    item['item_variant'] = $el.attr('data-item_variant') || '';
    item['item_list_id'] = $el.attr('data-item_list_id') || '';
    item['item_list_name'] = $el.attr('data-item_list_name') || window.location.pathname;
    item['quantity'] = 1;
    item['product_availability'] = $el.attr('data-product_availability') || '';
    item['product_deal_id'] = String($el.attr('data-product_deal_id') || '');
    item['product_data_variation'] = $el.attr('data-product_data_variation') || '';
    item['product_third_party_code'] = $el.attr('data-product_third_party_code') || '';
    item['product_tariff_code'] = $el.attr('data-product_tariff_code') || '';
    item['product_up_front_cost'] = $el.attr('data-product_up_front_cost') || '';
    item['product_model'] = $el.attr('data-product_model') || '';
    item['product_capacity'] = $el.attr('data-product_capacity');
    item['deal_tag'] = dealTagStr || '';
    item['product_card_ribbon'] = $el.attr('data-product_card_ribbon') ? $el.attr('data-product_card_ribbon') : '';
    item['product_promotion'] = $el.attr('data-product_promotion') ? $el.attr('data-product_promotion') : '';
    item['5g_enabled'] = $el.attr('data-5g_enabled') || '';
    item['e_sim_enabled'] = $el.attr('data-e_sim_enabled') || '';
    items.push(item);
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;
    dataLayer.push({
        ecommerce: null
    });

    dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
            currency: 'GBP',
            value: Number($el.attr('data-price')),
            'items': items
        }
    });
});

$(document).on('click', '.accessory-add-to-basket[data-remove-accessory]', function() {
    var btn = $(this);
    var items = [];
    var item = {};
    // var parentVoucher = $(this).find('.accessory-add-to-basket').data('parent-id');
    // var productParentFamily = $('.basket-item[data-public-id="' + parentVoucher + '"]').attr('data-product-family').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

    item['item_id'] = btn.attr('data-product-code') || '';
    item['item_name'] = 'Accessories: ' + btn.attr('data-product-name') || '';
    item['price'] = Number(btn.attr('data-price')) || '';
    item['item_brand'] = btn.attr('data-brand') || '';
    item['item_category'] = 'ACC';
    item['item_category2'] = '';
    item['item_category3'] = '';
    item['item_category4'] = '';
    item['item_category5'] = '';
    item['item_variant'] = '';
    item['item_list_id'] = btn.attr('data-item_list_id') || '';
    item['item_list_name'] = btn.attr('data-item_list_name') || window.location.pathname;
    item['quantity'] = 1;
    item['product_availability'] = 'In Stock';
    item['product_deal_id'] = String(btn.attr('data-deal-id')) || '';
    item['product_data_variation'] = '';
    item['product_third_party_code'] = btn.attr('data-thirdparty-code') || '';
    item['product_tariff_code'] = btn.attr('data-tariffcode') || '';
    item['product_up_front_cost'] = btn.attr('data-price') || '';
    item['product_model'] = 'Accessories';
    item['deal_tag'] = '';
    item['product_card_ribbon'] = '';
    item['product_promotion'] = '';
    item['5g_enabled'] = '';
    item['e_sim_enabled'] = '';
    items.push(item);
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;
    dataLayer.push({
        ecommerce: null
    });

    dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
            'currency': 'GBP',
            'value': Number(btn.attr('data-price')),
            // 'item_list_name': 'basket_accessories_carousel_' + productParentFamily,
            'items': items
        }
    });
});
